// extracted by mini-css-extract-plugin
module.exports = {"colorInput":"color-input-module__colorInput___1g01q","colorSelector":"color-input-module__colorSelector___3sfcx"};